<template>
  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="需求大厅名称">
          <el-input placeholder="请输入需求大厅名称" v-model="formInline.search"></el-input>
        </el-form-item>
        
        <!-- 状态筛选 -->
        <el-form-item label="状态">
          <el-select v-model="formInline.status" placeholder="请选择状态" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option label="待审核" value="0"></el-option>
            <el-option label="审核通过" value="1"></el-option>
            <el-option label="审核不通过" value="2"></el-option>
            <el-option label="待确认" value="3"></el-option>
            <el-option label="进行中" value="4"></el-option>
            <el-option label="已完成" value="5"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加需求大厅</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
      
            <el-table-column prop="requirement_hall_id" label="ID" width="80"></el-table-column>
            <el-table-column prop="requirement_type_id" label="关联需求类型ID"></el-table-column>
            <el-table-column prop="name" label="需求大厅名称"></el-table-column>
            <el-table-column prop="address" label="详细地址"></el-table-column>
            
            <!-- 状态列 -->
            <el-table-column prop="status" label="状态" width="100">
              <template slot-scope="scope">
                <el-tag 
                  :type="getStatusTagType(scope.row.status)" 
                  size="small"
                  effect="plain">
                  {{ getStatusText(scope.row.status) }}
                </el-tag>
              </template>
            </el-table-column>
            
            <el-table-column prop="budget_amount" label="预算金额"></el-table-column>
            <el-table-column prop="contact_information" label="手机号"></el-table-column>
            <el-table-column prop="sort" label="排序"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            
            <el-table-column fixed="right" label="操作" width="180">
              <template slot-scope="scope">
                <!-- 根据状态显示不同的操作按钮 -->
                <div class="action-buttons">
                  <!-- 待审核状态（status=0） -->
                  <template v-if="scope.row.status == 0">
                    <el-button 
                      @click="approveClick(scope.row, 1)" 
                    type="text" size="small"
                      plain
                      title="审核通过">
                      审核
                    </el-button>
                    <!-- <el-button 
                      @click="approveClick(scope.row, 2)" 
                      type="danger" 
                      size="mini" 
                      plain
                      title="审核不通过">
                      拒绝
                    </el-button> -->
                  </template>
                  
                  <!-- 已审核状态（可以查看和编辑） -->
                  <template v-else>
                    <!-- 查看按钮 -->
                    <el-button 
                      @click="viewDetail(scope.row)" 
                      type="text" size="small"
                      plain
                      title="查看详情">
                      查看
                    </el-button>
                  </template>
                  
                  <!-- 通用操作按钮 -->
                  <el-button 
                    @click="editClick(scope.row)" 
                    type="text" size="small"
                    plain
                    title="编辑">
                    编辑
                  </el-button>
                  <el-button 
                    @click="deleteClick(scope.row)" 
                    type="text" size="small"
                    plain
                    title="删除">
                    删除
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <!-- 添加组件 -->
    <Add :open_add="open_add" v-if="open_add" @close="closeAdd"></Add>
    
    <!-- 编辑组件 -->
    <Edit :open_add="open_edit" :requirement_hall_id="requirement_hall_id" v-if="open_edit" @close="closeEdit"></Edit>
    
    <!-- 审核对话框 -->
    <el-dialog 
      :title="auditDialog.title" 
      :visible.sync="auditDialog.visible" 
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true">
      
      <el-form :model="auditForm" ref="auditForm" label-width="100px">
        <el-form-item label="审核操作" prop="action">
          <el-radio-group v-model="auditForm.action">
            <el-radio :label="1">审核通过</el-radio>
            <el-radio :label="2">审核不通过</el-radio>
          </el-radio-group>
        </el-form-item>
        
        <el-form-item 
          label="审核备注" 
          prop="remark"
          v-if="auditForm.action == 2">
          <el-input
            type="textarea"
            :rows="4"
            v-model="auditForm.remark"
            placeholder="请输入审核不通过的原因（选填）"
            maxlength="200"
            show-word-limit>
          </el-input>
        </el-form-item>
        
        <el-form-item label="需求信息" v-if="currentAuditRow">
          <div style="font-size: 12px; color: #666;">
            <p><strong>需求名称：</strong>{{ currentAuditRow.name }}</p>
            <p><strong>发布人：</strong>用户ID {{ currentAuditRow.user_id }}</p>
            <p><strong>预算金额：</strong>¥{{ currentAuditRow.budget_amount }}</p>
            <p><strong>联系方式：</strong>{{ currentAuditRow.contact_information }}</p>
            <p><strong>创建时间：</strong>{{ currentAuditRow.create_time }}</p>
          </div>
        </el-form-item>
      </el-form>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="auditDialog.visible = false">取 消</el-button>
        <el-button type="primary" @click="confirmAudit" :loading="auditLoading">确 定</el-button>
      </span>
    </el-dialog>
    
    <!-- 查看详情对话框 -->
    <el-dialog 
      title="需求详情" 
      :visible.sync="detailDialog.visible" 
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      
      <el-descriptions :column="2" border v-if="currentDetailRow">
        <el-descriptions-item label="需求ID">{{ currentDetailRow.requirement_hall_id }}</el-descriptions-item>
        <el-descriptions-item label="需求名称">{{ currentDetailRow.name }}</el-descriptions-item>
        <el-descriptions-item label="需求类型ID">{{ currentDetailRow.requirement_type_id }}</el-descriptions-item>
        <el-descriptions-item label="发布人ID">{{ currentDetailRow.user_id }}</el-descriptions-item>
        <el-descriptions-item label="预算金额">¥{{ currentDetailRow.budget_amount }}</el-descriptions-item>
        <el-descriptions-item label="保证金">¥{{ currentDetailRow.budget_deposit }}</el-descriptions-item>
        <el-descriptions-item label="联系方式">{{ currentDetailRow.contact_information }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag :type="getStatusTagType(currentDetailRow.status)" size="small">
            {{ getStatusText(currentDetailRow.status) }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="详细地址" :span="2">{{ currentDetailRow.address }}</el-descriptions-item>
        <el-descriptions-item label="需求描述" :span="2">
          <div v-html="currentDetailRow.intro" style="max-height: 200px; overflow-y: auto;"></div>
        </el-descriptions-item>
        <el-descriptions-item label="完成时间">{{ currentDetailRow.completion_date }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ currentDetailRow.create_time }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{ currentDetailRow.update_time }}</el-descriptions-item>
      </el-descriptions>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialog.visible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import Requirement_hallApi from '@/api/requirement_hall.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';

  export default {
    components: {
      Add,
      Edit,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search: "",
          status: ""
        },
        
        open_add: false,
        open_edit: false,
        requirement_hall_id: "",
        
        /* 审核相关数据 */
        auditDialog: {
          visible: false,
          title: "审核需求"
        },
        auditForm: {
          action: 1, // 1:通过，2:不通过
          remark: ""
        },
        auditLoading: false,
        currentAuditRow: null,
        
        /* 详情相关数据 */
        detailDialog: {
          visible: false
        },
        currentDetailRow: null
      };
    },
    created() {
      /*获取列表*/
      this.getTableList();
    },
    methods: {
      /* 状态文本转换 */
      getStatusText(status) {
        const statusMap = {
          0: '待审核',
          1: '审核通过',
          2: '审核不通过',
          3: '待确认',
          4: '进行中',
          5: '已完成'
        };
        return statusMap[status] || '未知状态';
      },
      
      /* 状态标签类型 */
      getStatusTagType(status) {
        const typeMap = {
          0: 'warning',   // 待审核 - 黄色
          1: 'success',   // 审核通过 - 绿色
          2: 'danger',    // 审核不通过 - 红色
          3: 'info',      // 待确认 - 蓝色
          4: 'primary',   // 进行中 - 蓝色
          5: ''           // 已完成 - 默认
        };
        return typeMap[status] || '';
      },
      
      /* 重置搜索 */
      resetSearch() {
        this.formInline = {
          search: "",
          status: ""
        };
        this.curPage = 1;
        this.getTableList();
      },
      
      /*关闭添加*/
      closeAdd(e) {
        this.open_add = false;
        this.getTableList();
      },
      
      closeEdit(e) {
        this.open_edit = false;
        this.getTableList();
      },
      
      getData() {
        this.curPage = 1;
        this.getTableList();
      },
      
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },
      
      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },
      
      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = Object.assign({}, this.formInline);
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        
        Requirement_hallApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
            self.loading = false;
            console.error('获取列表失败:', error);
          });
      },
      
      /*添加需求*/
      addClick() {
        this.open_add = true;
      },
      
      /*编辑需求*/
      editClick(row) {
        this.requirement_hall_id = row.requirement_hall_id;
        this.open_edit = true;
      },
      
      /*查看详情*/
      viewDetail(row) {
        this.currentDetailRow = row;
        this.detailDialog.visible = true;
      },
      
      /* 审核按钮点击 */
      approveClick(row, action) {
        this.currentAuditRow = row;
        this.auditForm.action = action;
        this.auditForm.remark = "";
        this.auditDialog.title = `审核需求 - ${row.name}`;
        this.auditDialog.visible = true;
      },
      
      /* 确认审核 */
      confirmAudit() {
        if (!this.currentAuditRow) return;
        
        this.auditLoading = true;
        const params = {
          requirement_hall_id: this.currentAuditRow.requirement_hall_id,
          status: this.auditForm.action, // 1:通过，2:不通过
          remark: this.auditForm.remark || ""
        };
        
        Requirement_hallApi.audit(params, true)
          .then(res => {
            this.auditLoading = false;
            if (res.code == 1) {
              this.$message.success('审核成功');
              this.auditDialog.visible = false;
              this.getTableList(); // 刷新列表
            } else {
              this.$message.error(res.msg || '审核失败');
            }
          })
          .catch(error => {
            this.auditLoading = false;
            this.$message.error('审核失败，请重试');
            console.error('审核失败:', error);
          });
      },
      
      /*删除*/
      deleteClick(row) {
        let self = this;
        self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          Requirement_hallApi.del(
            {
              requirement_hall_id: row.requirement_hall_id
            },
            true
          )
          .then(data => {
            if (data.code == 1) {
              self.$message({
                message: '删除成功',
                type: 'success'
              });
              this.getTableList();
            } else {
              self.$message.error(data.msg || '删除失败');
            }
          })
          .catch(error => {
            self.$message.error('删除失败');
          });
        })
        .catch(() => {});
      }
    }
  };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/plus/requirement_hall/index/index.vue